<!-- <div [ngClass]="{'panel-open': isOpen}" class="panel">
	<div class="panel-content"> -->
	  <!-- Contenido del panel -->

		<div class="recuadro">

			<h3 class="titulo">Panel de evaluación</h3>

			<table class="table table-bordered">
				<thead>
					<tr>
						<th>PARÁMETROS A EVALUAR</th>
						<th>EVALUACIÓN</th>
						<th>COMENTARIOS</th>
						<!-- <th>Qty</th>
						<th>Total</th> -->
					</tr> 
				</thead>
				<tbody>
					<tr *ngFor="let item of formulario.formulario" >
						<td class="text-parameters">
							<span><strong>{{item.title}}</strong></span>
							<br>
							<br>
							<span class="parameters">{{item.parametrosEvaluacion}}</span>
						</td>
						<td>
							<div>
								<div *ngFor="let eval of item.evaluaciones" class="container-selectores">
									<ng-select [ngClass]="(eval.value)? 'ng-selected' : ''"  bindLabel="name" bindValue="id"  
										(change)="updateValueForm($event, eval.parameter +'-S' ,item.parameter, eval)"
												 [placeholder]="(eval.value)?  '' :'Seleccione una opción'" [clearable]="false"
										[disabled]="evaluacionFinalizada && !Admin" [items]="eval.opciones" [(ngModel)]="eval.value" class="ng-select"></ng-select>

									<input *ngIf="eval.value" class="input-calificacion"  [min]="(eval.value==1)? 9: (eval.value==2)?  5: 0 "
										[max]="(eval.value==1)? 10: (eval.value==2)?  8: 4"	 type="number" name="calificacion"
										(change)="paramChangedForm($event, eval.parameter+'-C', item.parameter, eval, item)"
										[(ngModel)]="eval.calificacion" [disabled]="evaluacionFinalizada && !Admin"
										[value]="eval.calificacion"
										(keydown)="onInputKeyDown($event)"
										>		
										
										
								</div>
							</div>
							
							

							<div class="calificacion">
								<span> Calificación ponderada: <strong>{{item.calificacion}}</strong></span>
							</div>
						</td>
						<td>
							<textarea class="text-area" type="text" [value]="item.comentarios || ''"
								[disabled]="evaluacionFinalizada && !Admin"
								(change)="paramChangedForm($event, item.parameter, item.parameter, item, item)"
								autocomplete="nope"></textarea>
						</td>
					</tr>
					<!-- (change)="paramChangedForm($event, item.parameter, cardForm.subgrupo, item)" -->
					<!-- <tr>
						<td class="w-25 text-center">
							<button type="button" class="close text-danger font-2x" data-dismiss="alert" aria-label="Close">
								<span aria-hidden="true"><i class="ion-ios-close"></i></span>
							</button>
						<div class="p-img">
							<img src="assets/img/3.jpg" alt="product image" class="img-fluid card-shadow" width="180" height="180" />
							</div>
						</td>
						<td>Slick Top</td>
						<td>$55.00</td>
						<td class="w-15 cart-number"><input class="form-control" placeholder="1" type="number" value="3"></td>
						<td>$55.00</td>
					</tr>
					<tr>
						<td class="w-25 text-center">
							<button type="button" class="close text-danger font-2x" data-dismiss="alert" aria-label="Close">
								<span aria-hidden="true"><i class="ion-ios-close"></i></span>
							</button>
							<div class="p-img">
							<img src="assets/img/4.jpg" alt="product image" class="img-fluid card-shadow" width="180" height="180" />
							</div>
						</td>
						<td>Zipped Top</td>
						<td>$30.00</td>
						<td class="w-15 cart-number"><input class="form-control" placeholder="1" type="number" value="2"></td>
						<td>$30.00</td>
					</tr> -->
				</tbody>
			</table>

			<div class="">
				<span><strong> Comentario general: <i>(mínimo 200 caracteres faltan: {{numberCharactersLeft}}) </i></strong></span>
				<textarea class="text-area" type="text"  value="{{comentario}}" [disabled]="evaluacionFinalizada && !Admin"
				(change)="commentChangedForm($event,  'comentario-gen')"
				(keyup)="countCharacters($event)"
				autocomplete="nope">
				</textarea>
			</div>


			<div class="calificacion">
				<span> Calificación general: <strong>{{calificacionTotal}} / 80</strong></span>
			</div>
			

			<div class="container-button" >
				<button class="button-siguiente" [disabled]="evaluacionFinalizada && !Admin" (click)="finalizarButton($event)" >FINALIZAR EVALUACIÓN</button>
			  </div>
		</div>
	  



<!-- 	  
	</div>
  </div>
 -->



